import { createColumnHelper } from '@tanstack/react-table';
import { Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import { Event, Business } from 'services/@types';

const columnHelper = createColumnHelper<Event>();

export default function useColumns(): any {
  const navigate = useNavigate();
  const textColor = useColorModeValue('navy.700', 'white');
  const brandColor = useColorModeValue('brand.500', 'brand.400');

  return [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Event Name
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="md" fontWeight="600">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('type', {
      id: 'type',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Type
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue() || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('dateAndTime', {
      id: 'dateAndTime',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Date
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue()
            ? new Date(info.getValue() as string).toLocaleDateString()
            : '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('businessID', {
      id: 'businessID',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Business
        </Text>
      ),
      cell: (info) => {
        const val = info.getValue();
        const name =
          typeof val === 'object' && val
            ? (val as Business).businessName
            : '-';
        return (
          <Text color={textColor} fontSize="sm">
            {name}
          </Text>
        );
      },
    }),
    columnHelper.accessor('numberOfGuests', {
      id: 'numberOfGuests',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Guests
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue() ?? '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('location', {
      id: 'location',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Location
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" maxW="200px" noOfLines={1}>
          {info.getValue()?.label || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => {},
      cell: (info) => (
        <Flex gap={5}>
          <Icon
            as={FaEye}
            color={brandColor}
            onClick={() =>
              navigate(`/admin/events/detail/${info.getValue()}`)
            }
            transition="all 0.2s linear"
            cursor="pointer"
            _hover={{ transform: 'scale(1.2)' }}
          />
        </Flex>
      ),
    }),
  ];
}
